import { render } from "./AlertArchived.vue?vue&type=template&id=4d29f498&scoped=true"
import script from "./AlertArchived.vue?vue&type=script&lang=js"
export * from "./AlertArchived.vue?vue&type=script&lang=js"

import "./AlertArchived.vue?vue&type=style&index=0&id=4d29f498&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d29f498"]])

export default __exports__